import React from 'react'

import Table from '../../../components/Table'
import Tag from '../../../components/Tag'

const ActionItem = ({ value, onOrderChange, lang }) => {
	return (
		<Table
			emptyText={lang('no-mapping')}
			rowMover={onOrderChange !== undefined}
			showHeader={false}
			onRowMove={onOrderChange}
			pagination={false}
			columns={[
				{
					width: 150,
					key: 'value',
					value: lang('title')
				},
				{
					width: 100,
					key: 'type',
					value: lang('type'),
					render: ({ value }) => {
						return <Tag type={value}>{value?.toLowerCase()}</Tag>
					},
					searchWithRender: true
				}
			]}
			data={value}
		/>
	)
}

export default ActionItem
